import api, { normalizeList } from './api';

export const getConsumables = async (filters = {}) => {
    try {
        // Use inventory endpoint for better data including current quantities
        let url = '/api/inventory/consumables/';
        const params = new URLSearchParams();
        
        // Add filters if provided
        if (filters.status === 'available') {
            params.append('status', 'available');
        }
        if (filters.serviceOrderId) {
            params.append('service_order_id', filters.serviceOrderId);
        }
        
        if (params.toString()) {
            url += `?${params.toString()}`;
        }
        
        const response = await api.get(url);
        let consumables = normalizeList(response.data);
        
        // Additional frontend filtering for available quantity
        if (filters.status === 'available') {
            consumables = consumables.filter(item => item.current_quantity > 0);
        }
        
        return consumables;
    } catch (error) {
        console.error('Error in getConsumables:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        return [];
    }
};

export const getConsumable = async (id) => {
    try {
        const response = await api.get(`/api/master-data/consumables/${id}/`);
        return response.data;
    } catch (error) {
        console.error('Error in getConsumable:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const createConsumable = async (data) => {
    try {
        const response = await api.post('/api/master-data/consumables/', data);
        return response.data;
    } catch (error) {
        console.error('Error in createConsumable:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const updateConsumable = async (id, data) => {
    try {
        const response = await api.put(`/api/master-data/consumables/${id}/`, data);
        return response.data;
    } catch (error) {
        console.error('Error in updateConsumable:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const deleteConsumable = async (id) => {
    try {
        await api.delete(`/api/master-data/consumables/${id}/`);
    } catch (error) {
        console.error('Error in deleteConsumable:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const addConsumableMovement = async (id, data) => {
    const response = await api.post(`/api/master-data/consumables/${id}/add_movement/`, data);
    return response.data;
}; 